import React, {useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Box, Button, Card, CardContent, CardHeader, Divider, makeStyles, TextField} from '@material-ui/core';
import {Alert} from "@material-ui/lab";
import axios from "axios";

const useStyles = makeStyles(({
    root: {}
}));

const Password = ({className, ...rest}) => {
    const classes = useStyles();
    const [values, setValues] = useState({
        currentPassword: '',
        password: '',
        confirm: ''
    });
    const [error, setError] = useState(null);
    const [message, setMessage] = useState(null);

    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    };

    const handleUpdate = () => {
        if (values.currentPassword !== '' && values.password !== '' && values.confirm !== '') {
            if (values.password === values.confirm) {
                if (values.password.length > 3) {
                    const body = {currentPassword: values.currentPassword, newPassword: values.password};
                    axios.post("user/updatePassword", body).then(response => {
                        setError(null);
                        setMessage(response.data.message);
                    }).catch(err => {
                        if (err.response) {
                            let {message} = err.response.data;
                            if (message)
                                setError(message)
                            else
                                setError("Passwords could not be changed. Try again later.")
                        } else {
                            setError("Passwords could not be changed. Try again later.")
                        }
                        setMessage(null);
                    });
                } else {
                    setError("New password too sort. Min 4 character.");
                    setMessage(null);
                }
            } else {
                setError("Passwords are not the same.");
                setMessage(null);
            }
        } else {
            setError("Please fill all field");
            setMessage(null);
        }
    }

    return (
        <form className={clsx(classes.root, className)} {...rest} >
            <Card>
                <CardHeader
                    subheader="Update password"
                    title="Password"
                />
                <Divider/>
                <CardContent>
                    {message && <Alert severity="success">{message}</Alert>}
                    {error && <Alert severity="error">{error}</Alert>}
                    <TextField
                        fullWidth
                        label="Current Password"
                        margin="normal"
                        name="currentPassword"
                        onChange={handleChange}
                        type="password"
                        value={values.currentPassword}
                        variant="outlined"
                    />
                    <TextField
                        fullWidth
                        label="Password"
                        margin="normal"
                        name="password"
                        onChange={handleChange}
                        type="password"
                        value={values.password}
                        variant="outlined"
                    />
                    <TextField
                        fullWidth
                        label="Confirm password"
                        margin="normal"
                        name="confirm"
                        onChange={handleChange}
                        type="password"
                        value={values.confirm}
                        variant="outlined"
                    />
                </CardContent>
                <Divider/>
                <Box display="flex" justifyContent="flex-end" p={2}>
                    <Button color="primary" variant="contained" onClick={handleUpdate}> Update </Button>
                </Box>
            </Card>
        </form>
    );
};

Password.propTypes = {
    className: PropTypes.string
};

export default Password;
